export default "__VITE_ASSET__D8oYGZ8d__"